import type { AnalysisResult } from '../../api/dashboards';

type Cell = AnalysisResult['rows'][number][string] | undefined;

/**
 * One result cell, as a person reads it.
 *
 * Numbers get thousands separators and at most two decimals; a date-only value
 * keeps its day rather than showing a midnight nobody asked about; an absent
 * value is an em dash, never a blank that looks like a zero.
 */
export function formatCell(value: Cell, type: string): string {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'number') {
    if (type === 'integer' || Number.isInteger(value)) return value.toLocaleString();
    return value.toLocaleString(undefined, { maximumFractionDigits: 2 });
  }
  if (/^\d{4}-\d{2}-\d{2}T00:00:00/.test(value)) return value.slice(0, 10);
  return value;
}
